import { LessonMessage } from '../generated/LessonMessage';
import { Student } from '../generated/Student';
import { Teacher } from '../generated/Teacher';

export class LessonMessageDTO {
  public messages: LessonMessage = new LessonMessage();
  public teacher: Teacher = new Teacher();
  public student: Student = new Student();
}
